
import {helpers} from '../reportingHelpers';
import {createTextFormatterObj} from '../../utils/tools';

let control = {
    render: function(def, ctx, callback, startLine = 0){
        let outPDF = ctx.rootContext.pdf;

        //Set the Fill (background) / Stroke (border) / Text colors...EK
        let s = def.Style;

        outPDF.setFont(s.fontName, s.fontWeight);
        outPDF.setFontSize(s.fontSize * outPDF.internal.scaleFactor);     //The style font will be in px, convert to scale factor...EK
        outPDF.setTextColor(s.color.r, s.color.g, s.color.b);

        let renderLeft = helpers.getRenderLeft(def, ctx),
            renderTop = helpers.getRenderTop(def, ctx);

        let borderTop = renderTop,
            borderHeight = def.runTime.height,

            /**
             * The estimated amount of height used by each line, including the spacing between lines
             * @type {number}
             */
            lineTopOffset = helpers.getLineOffset(s.fontSize) * outPDF.internal.scaleFactor,

            /**
             * Fudge factor for line spacing. :/
             * @type {number}
             */
            lineSpace = helpers.getLineSpacing(s.fontSize);

        if (startLine > 0) {
            // we need to offset the border top and height
            borderTop += lineTopOffset * startLine;
        }

        // is this border outside of the current printable area?
        // if it is - the entire label will be outside, as well.
        if (ctx.renderingDetail && borderTop > ctx.rootContext.detailBounds.bottom) {
            ctx.controls.pageBreak.render(
                {
                    runTime: {
                        forceBreak: true,
                        top: def.runTime.top
                    }
                },
                ctx,
                () => {
                    // continue rendering "detail"
                    ctx.renderingDetail = true;

                    // we need to keep this page from being "popped" off later.
                    ctx.activePageBreak = false;

                    // render this control after the page break.
                    control.render(def, ctx, callback, startLine);
                });

            // stop processing here as it will continue through the render() call after the page break.
            return;
        }

        if (s.borderWidth != null && s.borderWidth > 0){
            outPDF.setLineWidth(s.borderWidth);
            outPDF.setDrawColor(s.borderColor.r, s.borderColor.g, s.borderColor.b);

            if (s.background != null){
                outPDF.setFillColor(s.background.r, s.background.g, s.background.b, null);
                outPDF.roundedRect(renderLeft, borderTop, def.Width, borderHeight, s.borderRadius, s.borderRadius, 'B');      // The B Style fills the rectangle with the fill color set...EK
            }
            else {
                // They want only a border with no background.  To do this we need to draw all four lines
                outPDF.roundedRect(renderLeft, borderTop, def.Width, borderHeight, s.borderRadius, s.borderRadius);
            }
        }
        else if (s.background != null){
            outPDF.setFillColor(s.background.r, s.background.g, s.background.b, null);
            outPDF.rect(renderLeft, renderTop, def.Width, def.runTime.height, 'F');
        }

        // add the padding after it is used for the border/background.
        renderTop += s.padding;

        let textLeft = renderLeft + s.padding,
            textMetrics = def.runTime.textMetrics;

        // The jsPDF has a bug in the center alignment where it assumes the first line is the longest.  For now, we are going to break up multi-line into seperate calls...EK
        let midPoint = renderLeft + (def.Width / 2);

        // The jsPDF has a bug in the right alignment where it assumes the first line is the longest.  For now, we are going to break up multi-line into seperate calls...EK
        let rightPoint = renderLeft + def.Width;

        for (let line = startLine, lineCount = textMetrics.lines.length; line < lineCount; line++) {
            let text = textMetrics.lines[line],
                currHeight = lineTopOffset * (line + 1);

            switch (s.textAlign) {
                case 'center':
                    textLeft = midPoint - (textMetrics.lineWidths[line] / 2);
                    break;
                case 'right':
                    textLeft = rightPoint - textMetrics.lineWidths[line];
                    break;
                default:
                    // already set the left start; nothing to do here.
            }

            let textTop = renderTop + currHeight + (lineSpace * line);

            if (ctx.renderingDetail && textTop > ctx.rootContext.detailBounds.bottom) {
                ctx.controls.pageBreak.render(
                    {
                        runTime: {
                            forceBreak: true,

                            // note we have to remove the line size we added to it at beginning of loop
                            top: def.runTime.top + currHeight - lineTopOffset
                        }
                    },
                    ctx,
                    () => {
                        // continue rendering "detail"
                        ctx.renderingDetail = true;

                        // we need to keep this page from being "popped" off later.
                        ctx.activePageBreak = false;

                        // continue rendering the lines
                        control.render(def, ctx, callback, line);
                    });

                // stop processing here as it will continue through the render() call after the page break.
                return;
            }

            outPDF.text(text,
                textLeft,
                textTop,
                {}, null, null);
        }

        callback();
    },
    preRender: function(def, ctx, callback){
        //Determine the text that will be rendered on this label...EK
        let s = def.Style,
            firstRender = false,
            runTime;

        if (def.runTime == null){
            firstRender = true;
            //This is the first time this control has been pre-rendered.  Create the runTime Object...EK
            def.runTime = {
                top: def.Top,
                width: def.Width,
                height: def.Height,
                text: ''
            };
        }
        else {
            // Don't reset the height runTime values here...
            //     Note: Since we can have static text and measuring text is process intensive, we only calculate either the first render or if the expression could change the value...EK
            def.runTime.top = def.Top;      // Reset the top in case of growth layout changes...EK
        }

        runTime = def.runTime;

        //We have rendered this control before, If it has an expression we need to eval and check it's size again... EK
        //      If not, we don't need to check the size again for a static text, just callback...EK
        if (def.Expression != null){
            runTime.dvExpr = new app.dv.helpers.expression.create(null, ctx.mvc.drivingView.ViewID, def.Expression, null, ctx.mvc);

            if (firstRender){
                try {
                    runTime.text = runTime.dvExpr.evaluate(ctx.mvc.drivingView.ViewID, ctx.dataContext);
                }
                catch (e) {
                    runTime.text = e.toString();
                }

                // ##PageNumber ##PageCount
                //If the formula doesn't contain the "vfp - view for property" function, then we only want to run this expression once...EK
                if (runTime.dvExpr.formula.indexOf('.vfp(') === -1
                    && runTime.dvExpr.formula.indexOf('.vfpgv(') === -1) {

                    //There is no property used (either raw or grid value), don't evaluate this again...EK
                    def.Expression = null;
                    def.Text = runTime.text;
                }
            }
            else {
                runTime.text = runTime.dvExpr.evaluate(ctx.mvc.drivingView.ViewID, ctx.dataContext);

                // Since this text changed, we need to account for the text measurement again, reset the runTime height...EK
                def.runTime.height = def.Height;
            }
        }
        else {
            //This is a static control, set the text..EK
            if (firstRender === false) {
                callback();     //We don't need to set the text and measure it again... just return...EK
                return;
            }
            else {
                runTime.text = (def.Text == null ? '' : def.Text);
            }
        }

        // Flush out the text value if the expression result is a zero length string...EK
        if (def.Expression != null && (runTime.text == null || runTime.text === '')){
            runTime.text = app.dv.reporting.globalSettings.showBlankFieldsAs;
        }

        if (runTime.TextFormatterObj == null && def.DisplayFormat != null) {
            // Create a text formatter object
            createTextFormatterObj(runTime.text, def.DisplayFormat, runTime, null);
        }

        if (runTime.TextFormatterObj != null) {
            runTime.text = runTime.TextFormatterObj.format(runTime.text);
        }

        if (typeof runTime.text !== 'string') {
            runTime.text = runTime.text.toString();
        }

        //      NOTE: the runTime.text is a string and will be converted to an Array when we set it to the textSize return value...EK
        //Determine the size of the control (take into account wrapping, and distance between lines) ... EK
        runTime.textMetrics = helpers.fitText(s.fontName, s.fontSize, s.fontWeight, runTime.text, def.Width, s.padding);

        if (runTime.textMetrics.height > def.Height) {
            //This content is larger than what has been defined, it needs to grow...EK
            //TODO: check a setting to see if this control can grow, otherwise it needs to truncate??
            runTime.grown = true;

            runTime.height = runTime.textMetrics.height;
        }
        else if (runTime.textMetrics.height < def.Height) {
            //this content is smaller... EK (TODO: Later we can allow controls to shrink...EK)
            //For now, don't modify the runTime, make them equal...EK
            runTime.height = def.Height;
            runTime.grown = false;
        }
        else{
            //We have an exact match... Make sure the run-time matches...EK
            runTime.height = def.Height;
            runTime.grown = false;
        }

        callback();
    }
};

export default control;
